import styled from "@emotion/styled";

export const Divider = styled.div`
    width: 1px;
    background-color: #e3e3e3;
`;
